module.exports = __webpack_public_path__ + "static/media/44.73b6ce48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/44.jpg
// module id = 304
// module chunks = 0